import React from 'react';
import { useTranslation } from 'react-i18next';
import { ITransactionStatistics } from '../types';

const StatCard: React.FC<{ label: string; value: string | number; variant?: 'success' | 'failed' }> = ({
  label,
  value,
  variant,
}) => (
  <div className="col-6 col-md-3 mb-3">
    <div className={`card h-100 gg-stat-card${variant ? ` gg-stat-card--${variant}` : ''}`}>
      <div className="card-body py-3">
        <div className="gg-stat-value">{value}</div>
        <div className="gg-stat-label">{label}</div>
      </div>
    </div>
  </div>
);

const StatsPanel: React.FC<{ stats: ITransactionStatistics }> = ({ stats }) => {
  const { t } = useTranslation();
  const ratePct = (stats.successRate * 100).toFixed(1);

  return (
    <div className="gg-stats-panel">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="gg-section-title mb-0">{t('Statistics')}</div>
        <span className="small text-muted">
          {stats.windowDays > 0 ? t('LastNDays', { count: stats.windowDays }) : t('AllTime')}
        </span>
      </div>
      <div className="row">
        <StatCard label={t('TotalCalls')} value={stats.totalCalls} />
        <StatCard label={t('Successful')} value={stats.successful} variant="success" />
        <StatCard label={t('Failed')} value={stats.failed} variant="failed" />
        <StatCard label={t('SuccessRate')} value={`${ratePct}%`} />
      </div>
    </div>
  );
};

export default StatsPanel;
